import { httpCreate } from './http';

const http = httpCreate('/srv/content');

export const content = {
	//timeOrder
	getStickContent(id) {
		return http.get(`/getStickContent/${id}`);
	},
	getLive(id, page, pageSize, params) {
		// 因为存在请求被浏览器缓存到硬盘问题，所以在此处进行缓存设置
		return http.get(`/getRecentActivity/${id}/${page}/${pageSize}`, {
			params,
			headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
		});
	},
	getInfoById(contentId) {
		return http.get(`/${contentId}`);
	},
	add(id, data) {
		return http.post('/add/' + id, data);
	},
	update(id, data) {
		return http.post('/update/' + id, data);
	},
	delete(id) {
		return http.delete(`/delete/${id}`);
	},
	stickSign(id, num) {
		return http.post(`/stick/${id}/${num}`);
	},
	//timeOrder
	getAllImgUrls(id, params) {
		return http.get('/' + id + '/allImgUrls', { params });
	},
	creatDocx(id) {
		return http.get(`/${id}/exportWord`, { timeout: 300e3 });
	},
	getDraftList(id) {
		return http.get(`/${id}/draftList`);
	},
	publishDraft(id) {
		return http.post(`/${id}/publishDraft`);
	},
};
